import { render, staticRenderFns } from "./api.vue?vue&type=template&id=39d4f276&scoped=true&"
import script from "./api.vue?vue&type=script&lang=js&"
export * from "./api.vue?vue&type=script&lang=js&"
import style0 from "./api.vue?vue&type=style&index=0&id=39d4f276&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39d4f276",
  null
  
)

export default component.exports